import { X, Download, Loader2 } from 'lucide-react'
import { PreviewSidebar } from './PreviewSidebar'
import { PreviewOptions, ChatStats } from '../types/preview'
import './MobileOptionsSheet.css'

interface Props {
  isOpen: boolean
  onClose: () => void
  options: PreviewOptions
  setOptions: (opts: PreviewOptions) => void
  stats: ChatStats
  agbCheckbox: boolean
  setAgbCheckbox: (v: boolean) => void
  widerrufsCheckbox: boolean
  setWiderrufsCheckbox: (v: boolean) => void
  onCheckout: () => void
  isRendering: boolean
  onFreePdf?: () => void
  isGeneratingFreePdf?: boolean
}

export function MobileOptionsSheet({
  isOpen,
  onClose,
  options,
  setOptions,
  stats,
  agbCheckbox,
  setAgbCheckbox,
  widerrufsCheckbox,
  setWiderrufsCheckbox,
  onCheckout,
  isRendering,
  onFreePdf,
  isGeneratingFreePdf = false,
}: Props) {
  return (
    <>
      {/* Backdrop */}
      <div
        className={`mos-backdrop ${isOpen ? 'visible' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Sheet */}
      <div className={`mos-sheet ${isOpen ? 'open' : ''}`} role="dialog" aria-label="Optionen">
        {/* Drag handle */}
        <div className="mos-handle-bar">
          <div className="mos-handle" />
        </div>

        {/* Header */}
        <div className="mos-header">
          <span className="mos-title">Optionen</span>
          <button className="mos-close" onClick={onClose} aria-label="Schließen">
            <X size={20} />
          </button>
        </div>

        {/* Scrollable options */}
        <div className="mos-body">
          <PreviewSidebar
            options={options}
            setOptions={setOptions}
            stats={stats}
            agbCheckbox={agbCheckbox}
            setAgbCheckbox={setAgbCheckbox}
            widerrufsCheckbox={widerrufsCheckbox}
            setWiderrufsCheckbox={setWiderrufsCheckbox}
            onCheckout={onCheckout}
            isRendering={isRendering}
          />
        </div>

        {/* Checkout footer — pinned at bottom */}
        <div className="mos-footer">
          <label className="mos-checkbox">
            <input
              type="checkbox"
              checked={agbCheckbox}
              onChange={e => setAgbCheckbox(e.target.checked)}
            />
            <span>
              Ich habe die{' '}
              <a href="/agb.html" target="_blank" rel="noopener">AGB</a>{' '}
              und{' '}
              <a href="/datenschutz.html" target="_blank" rel="noopener">Datenschutzerklärung</a>{' '}
              gelesen und akzeptiere diese.
            </span>
          </label>

          <label className="mos-checkbox">
            <input
              type="checkbox"
              checked={widerrufsCheckbox}
              onChange={e => setWiderrufsCheckbox(e.target.checked)}
            />
            <span>
              Ich stimme zu, dass mit der PDF-Erstellung sofort nach der Zahlung begonnen wird,
              und bestätige, dass ich damit mein Widerrufsrecht verliere.
            </span>
          </label>

          <button
            className="mos-buy-btn"
            onClick={onCheckout}
            disabled={isRendering || !agbCheckbox || !widerrufsCheckbox}
          >
            {isRendering
              ? <><Loader2 size={20} className="mos-spinner" /> PDF wird erstellt...</>
              : <><Download size={20} /> Vollständiges PDF — €4,99</>
            }
          </button>

          {onFreePdf && (
            <>
              <div className="mos-free-divider"><span>oder</span></div>
              <button
                className="mos-free-btn"
                onClick={onFreePdf}
                disabled={isGeneratingFreePdf}
              >
                {isGeneratingFreePdf
                  ? <><Loader2 size={16} className="mos-spinner" /> Wird erstellt...</>
                  : <><Download size={16} /> Kostenlos (mit Wasserzeichen)</>
                }
              </button>
              <p className="mos-free-hint">50 Nachrichten · mit Wasserzeichen</p>
            </>
          )}
        </div>
      </div>
    </>
  )
}
